import React from 'react';

const Imprint = () => (
  <article>
    <p>
      Bildquelle: <a href="https://www.flickr.com/photos/65414366@N00/sets/72157636359023846/">Flickr - Flying Mouse2007</a>
    </p>
  </article>
);

export default Imprint;
